import { useState, useEffect } from "react";
import { Info, X } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

export const PromoBanner = () => {
  const [dismissed, setDismissed] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [text, setText] = useState("");
  const [mobileText, setMobileText] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      const { data } = await supabase
        .from("site_settings")
        .select("key, value")
        .in("key", ["promo_enabled", "promo_text", "promo_text_mobile"]);

      if (data) {
        const map = Object.fromEntries(data.map((s) => [s.key, s.value]));
        setEnabled(map.promo_enabled === "true");
        setText(map.promo_text || "");
        setMobileText(map.promo_text_mobile || "");
      }
      setLoaded(true);
    };

    fetchSettings();
  }, []);

  if (!loaded || !enabled || dismissed) return null;

  return (
    <div className="relative bg-primary text-primary-foreground py-2.5 px-4 text-[13px] font-medium">
      <div className="container flex items-center gap-2">
        <Info className="w-4 h-4 text-accent shrink-0" />
        <span
          className="hidden sm:inline"
          dangerouslySetInnerHTML={{ __html: text }}
        />
        <span
          className="sm:hidden text-xs"
          dangerouslySetInnerHTML={{ __html: mobileText }}
        />
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-md hover:bg-primary-foreground/10 transition-colors"
        aria-label="Dismiss promotion"
      >
        <X className="w-4 h-4 text-primary-foreground/60" />
      </button>
    </div>
  );
};
